import { render } from "./SiteDropdownField.vue?vue&type=template&id=4ed928e1"
import script from "./SiteDropdownField.vue?vue&type=script&lang=js"
export * from "./SiteDropdownField.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../irap-client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__